import { gql } from "@apollo/client";

const DATA_PAIR_FRAGMENT = gql`
  fragment dataPair on DataPair {
    key
    value
  }
`;

const CONTENT_BLOCKS_FRAGMENT = gql`
  fragment contentBlocks on ContentBlock {
    ... on MarkdownBlock {
      id
      label
      textValue: value
      style
    }
    ... on ImageBlock {
      id
      src
      altText
    }
    ... on BpCustomComponent {
      id
      customValue: value
      data {
        ... on ProsConsList {
          heading
          pros
          cons
        }
        ... on FreeGiftOfferCard {
          heading
          subText
        }
      }
    }
  }
`;

const ACTION_BLOCK_FRAGMENT = gql`
  fragment actionBlock on ActionBlock {
    primaryLabel
    primaryActionId
    secondaryLabel
    secondaryActionId
  }
`;

const MULTIPLE_CHOICE_OPTION_FRAGMENT = gql`
  fragment multipleChoiceOption on MultipleChoiceOption {
    id
    key
    label
    additionalTextMode
    additionalTextAttributes {
      ...dataPair
    }
  }
  ${DATA_PAIR_FRAGMENT}
`;

const BASE_STEP_FRAGMENT = gql`
  fragment baseStep on BaseStepType {
    id
    header
    metadata {
      ...dataPair
    }
    contentBlocks {
      ...contentBlocks
    }
    actions {
      ...actionBlock
    }
    tracking {
      event
      properties
    }
  }
  ${DATA_PAIR_FRAGMENT}
  ${CONTENT_BLOCKS_FRAGMENT}
  ${ACTION_BLOCK_FRAGMENT}
`;

const BINARY_CHOICE_STEP_FRAGMENT = gql`
  fragment binaryChoiceStep on BinaryChoiceStep {
    id
    header
    metadata {
      ...dataPair
    }
    contentBlocks {
      ...contentBlocks
    }
    actions {
      ...actionBlock
    }
    checkOption {
      ...dataPair
    }
    tracking {
      event
      properties
    }
  }
  ${DATA_PAIR_FRAGMENT}
  ${CONTENT_BLOCKS_FRAGMENT}
  ${ACTION_BLOCK_FRAGMENT}
`;

const MULTIPLE_CHOICE_STEP_FRAGMENT = gql`
  fragment multipleChoiceStep on MultipleChoiceStep {
    id
    header
    metadata {
      ...dataPair
    }
    contentBlocks {
      ...contentBlocks
    }
    actions {
      ...actionBlock
    }
    optionBlocks {
      ...multipleChoiceOption
    }
    tracking {
      event
      properties
    }
  }
  ${DATA_PAIR_FRAGMENT}
  ${CONTENT_BLOCKS_FRAGMENT}
  ${ACTION_BLOCK_FRAGMENT}
  ${MULTIPLE_CHOICE_OPTION_FRAGMENT}
`;

const RESULT_STEP_FRAGMENT = gql`
  fragment resultStep on ResultStep {
    id
    result
    title
    body
    tracking {
      event
      properties
    }
  }
`;

const STEP_FRAGMENT = gql`
  fragment step on Step {
    ...baseStep
    ...binaryChoiceStep
    ...multipleChoiceStep
    ...resultStep
  }
  ${BASE_STEP_FRAGMENT}
  ${BINARY_CHOICE_STEP_FRAGMENT}
  ${MULTIPLE_CHOICE_STEP_FRAGMENT}
  ${RESULT_STEP_FRAGMENT}
`;

export const MEMBERSHIP_MANAGEMENT_FLOW_FRAGMENT = gql`
  fragment membershipManagementFlow on MembershipManagementFlowResponse {
    step {
      ...step
    }
  }
  ${STEP_FRAGMENT}
`;

const BLOCKS_FRAGMENT = gql`
  fragment blocks on TextBlock {
    id
    label
    value
  }
`;
const ACTIONS_FRAGMENT = gql`
  fragment actions on ActionBlock {
    primaryActionId
    primaryLabel
    secondaryActionId
    secondaryLabel
  }
`;

export const MEMBERSHIP_MANAGEMENT_FRAGMENT = gql`
  fragment membershipManagement on MembershipManagementComponent {
    id
    header
    footer
    actions {
      ...actions
    }
    blocks {
      ...blocks
    }
  }
  ${BLOCKS_FRAGMENT}
  ${ACTIONS_FRAGMENT}
`;
